import React from "react";
import "./Discount_holder.css";

function Discount_holder({ discount, label }) {
  return (
    <>
      <section className="Discount_holder">
        <p>{label || `${discount}%`}</p>
      </section>
    </>
  );
}

export default Discount_holder;
